export interface generateVideoLinkProps {
  videoId: string;
}

export const generateVideoLink = ({ videoId }: generateVideoLinkProps) => {
  if (videoId) {
    return `${process.env.REACT_APP_API_SERVER_URL}/storage/${videoId}`;
  } else return "";
};
